<template>
  <div v-loading="loading">
    <el-row :gutter="20" style="margin-left: 0px;">
      <div v-for="(item, index) in deliveryPlatform" :key="index" :class="{ 'border delivery-block hover-color': true, active: item.active }" :style="{ cursor: item.error ? 'not-allowed' : 'pointer', color: item.error ? '#909399' : '#262626' }" @click="selectDelivery(item)">
        <div>{{ item.name }}</div>
        <div style="line-height: 14px">{{ item.amount }}{{ item.error ? item.remarks : "元" }}</div>
      </div>
    </el-row>
    <el-row type="flex" justify="end" style="margin-top: 10px;">
      <el-button type="primary" plain @click="onClose">取 消</el-button>
      <el-button type="primary" @click="sendDelivery">确 认</el-button>
    </el-row>
  </div>
</template>

<script>
import deliveryPlatform from "@/utils/deliveryPlatform.js"
export default {
  name: "DeliveryTabKfw",
  props: {
    orderInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deliveryPlatform: [{
        name: "快服务",
        logistic: "kfw-kfw",
        active: false,
        error: true,
        remarks: "价格计算中...",
        amount: "",
      }],
      loading: false,
    };
  },
  mounted() {
    console.log(44)
    this.getDeliveryPlatformList();
  },
  methods: {
    getDeliveryPlatformList() {
      this.topsAjax.get(`${this.baseUrls.deliveryKfw}/query`, { orderId: this.orderInfo.sid }).then((response) => {
        if (response.error) {
          this.$emit("handleUnderPrice", "kfw", "无运力");
        } else {
          this.$emit("handleUnderPrice", "kfw", response.amount);
        }
        this.$set(this.deliveryPlatform, 0, response);
      });
    },
    selectDelivery(item) {
      if (item.error) {
        return;
      }
      if (item.active) {
        item.active = false;
      } else {
        item.active = true;
      }
    },
    sendDelivery() {
      this.loading = true;
      let pf = this.deliveryPlatform.filter((item) => item.active);
      if (pf.length === 0) {
        this.$message({ message: "请选择配送平台", type: "warning" });
        return;
      }
      this.topsAjax.post(`${this.baseUrls.deliveryKfw}/add`, {
        orderId: this.orderInfo.sid,
        priceMark: pf[0].priceMark,
      }).then(() => {
        this.loading = false;
        this.$message({ message: "下单成功", type: "success" });
        this.$emit("handleConfirm");
      });
    },
    onClose() {
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="scss">
.el-popover__title {
  text-align: center;
}

.input145px {
  .el-input {
    width: 145px !important;
  }
}
</style>
<style lang="scss" scoped>
.el-descriptions-item__content > p {
  color: black;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form-item__content {
  display: block;
}

.delivery-platform-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.remaining-time {
  color: green;
}

.overdue-time {
  color: red;
}

.delivery-block {
  height: 70px;
  width: 180px;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.hover-color:hover {
  /* 鼠标悬停时的样式 */
  background-color: rgba(64, 158, 255, 0.21);
}

.active {
  background-color: rgba(64, 158, 255, 0.21);
}
</style>
